/** <huna-lens-tabs>: keeps lens tabs and the tile row in sync. Without JS the tabs stay hidden and all tiles stay visible. */
class HunaLensTabs extends HTMLElement {
  connectedCallback() {
    if ('enhanced' in this.dataset) return;
    this.list = this.querySelector('[role="tablist"]');
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[data-lens-panel]')];
    this.row = this.querySelector('.huna-lenses__tiles');
    if (!this.list || !this.tabs.length || this.tabs.length !== this.panels.length) return;
    this.list.hidden = false;
    this.tabs.forEach((t, i) => t.addEventListener('click', () => this.select(i)));
    this.panels.forEach((p, i) => {
      p.setAttribute('role', 'tabpanel');
      p.addEventListener('click', () => this.select(i));
    });
    this.list.addEventListener('keydown', (e) => this.onKey(e));
    // A row that scrolls sideways must be reachable by keyboard.
    this.row.setAttribute('role', 'group');
    this.row.setAttribute('aria-label', this.list.getAttribute('aria-label'));
    new ResizeObserver(() => {
      if (this.row.scrollWidth > this.row.clientWidth) this.row.tabIndex = 0;
      else this.row.removeAttribute('tabindex');
    }).observe(this.row);
    this.dataset.enhanced = '';
    this.select(0, false);
  }

  select(i, move = true, focus = false) {
    this.tabs.forEach((t, n) => {
      t.setAttribute('aria-selected', n === i);
      t.tabIndex = n === i ? 0 : -1;
    });
    this.panels.forEach((p, n) => {
      p.classList.toggle('is-active', n === i);
      p.tabIndex = n === i ? 0 : -1; // only the active panel is a tab stop
    });
    if (focus) this.tabs[i].focus({ preventScroll: true });
    if (!move) return;
    document.dispatchEvent(new CustomEvent('huna:lens-select', { detail: { index: i } }));
    // Sideways scrolling of the two rows only, so the page never jumps.
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const t = this.tabs[i];
    const { row } = this;
    const pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    this.list.scrollTo({ left: t.offsetLeft - (this.list.clientWidth - t.offsetWidth) / 2, behavior });
    row.scrollTo({ left: this.panels[i].offsetLeft - pad, behavior });
  }

  onKey(e) {
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    const n = this.tabs.length;
    const now = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    const to = { ArrowRight: now + 1, ArrowLeft: now - 1, Home: 0, End: n - 1 }[e.key];
    if (to === undefined) return;
    e.preventDefault();
    this.select((to + n) % n, true, true);
  }
}

if (!customElements.get('huna-lens-tabs')) customElements.define('huna-lens-tabs', HunaLensTabs);
